export var IllustrationErrorTypes = {
    SIMPLE_ERROR: 'simple error',
    PAGE_NOT_FOUND: 'page not found',
    NO_CONNECTION: 'no connection',
    FATAL_ERROR: 'fatal error',
    BAD_CONNECTION: 'bad connection',
    ERROR_404: '404',
    COME_BACK_LATER: 'come back later',
    LIST_IS_EMPTY: 'list is empty'
};
